import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import moment from "moment";

const RevenueOverviewChartNursePhysio = ({ value, nurseData, physioData }) => {
  //   console.log(value, nurseData);
  const [last30NurseData, setLast30NurseData] = useState([]);
  const [last30PhysioData, setLast30PhysioData] = useState([]);

  useEffect(() => {
    if (nurseData && nurseData.length > 0) processNurseLast30Days();
    if (physioData && physioData.length > 0) processPhysioLast30Days();
  }, [nurseData, physioData]);

  const processLast30Days = (data) => {
    const today = moment();
    const thirtyDaysAgo = moment(today).subtract(30, "days");
    const filteredData = data.filter((entry) => {
      const entryDate = moment(entry.dateTime);
      return entryDate.isBetween(thirtyDaysAgo, today, null, "[]");
    });

    const dailyDataArray = [];
    for (let i = 0; i <= 30; i++) {
      const currentDay = moment(thirtyDaysAgo)
        .add(i, "days")
        .format("YYYY-MM-DD");
      dailyDataArray.push({ date: currentDay, data: [] });
    }

    filteredData.forEach((entry) => {
      const entryDate = moment(entry.dateTime).format("YYYY-MM-DD");
      const dayObject = dailyDataArray.find((day) => day.date === entryDate);
      if (dayObject) {
        dayObject.data.push(entry);
      }
    });

    return dailyDataArray;
  };

  const processNurseLast30Days = () => {
    const processed = processLast30Days(nurseData);
    setLast30NurseData(processed);
  };

  const processPhysioLast30Days = () => {
    const processed = processLast30Days(physioData);
    setLast30PhysioData(processed);
  };

  const getOptions = () => {
    let nurseDownloadData = [];
    let physioDownloadData = [];
    let categories = [];
    const today = moment();

    switch (value) {
      case "Today":
        nurseDownloadData = Array.from({ length: 24 }, (_, i) => {
          const hour = moment().startOf("day").add(i, "hours").format("HH:00");
          const dayData = last30NurseData.find((item) =>
            moment(item.date).isSame(today, "day")
          );
          const count = dayData
            ? dayData.data.filter(
                (entry) => moment(entry.dateTime).format("HH:00") === hour
              ).length
            : 0;
          return count;
        });

        physioDownloadData = Array.from({ length: 24 }, (_, i) => {
          const hour = moment().startOf("day").add(i, "hours").format("HH:00");
          const dayData = last30PhysioData.find((item) =>
            moment(item.date).isSame(today, "day")
          );
          const count = dayData
            ? dayData.data.filter(
                (entry) => moment(entry.dateTime).format("HH:00") === hour
              ).length
            : 0;
          return count;
        });

        categories = Array.from({ length: 24 }, (_, i) =>
          moment().startOf("day").add(i, "hours").format("HH:00")
        );
        break;

      case "Last 7 days":
        nurseDownloadData = Array.from({ length: 7 }, (_, i) => {
          const date = moment()
            .subtract(6 - i, "days")
            .format("YYYY-MM-DD");
          const dayData = last30NurseData.find((item) => item.date === date);
          return dayData ? dayData.data.length : 0;
        });

        physioDownloadData = Array.from({ length: 7 }, (_, i) => {
          const date = moment()
            .subtract(6 - i, "days")
            .format("YYYY-MM-DD");
          const dayData = last30PhysioData.find((item) => item.date === date);
          return dayData ? dayData.data.length : 0;
        });

        categories = Array.from({ length: 7 }, (_, i) =>
          moment()
            .subtract(6 - i, "days")
            .format("ddd, MMM D")
        );
        break;

      case "Last 30 days":
        nurseDownloadData = last30NurseData.map((d) => d.data.length);
        physioDownloadData = last30PhysioData.map((d) => d.data.length);
        categories = last30NurseData.map((d) => moment(d.date).format("MMM D"));
        break;

      case "Over All": {
        const allDates = [...nurseData, ...physioData].map((entry) =>
          moment(entry.dateTime).startOf("day").format("YYYY-MM-DD")
        );
        const uniqueDates = [...new Set(allDates)];
        const startDate = moment(
          Math.min(...uniqueDates.map((d) => new Date(d).getTime()))
        );
        const endDate = moment(
          Math.max(...uniqueDates.map((d) => new Date(d).getTime()))
        );

        const dateRange = [];
        for (
          let m = startDate.clone();
          m.isSameOrBefore(endDate);
          m.add(1, "day")
        ) {
          dateRange.push(m.format("YYYY-MM-DD"));
        }

        nurseDownloadData = dateRange.map(
          (date) =>
            nurseData.filter(
              (entry) => moment(entry.dateTime).format("YYYY-MM-DD") === date
            ).length
        );
        physioDownloadData = dateRange.map(
          (date) =>
            physioData.filter(
              (entry) => moment(entry.dateTime).format("YYYY-MM-DD") === date
            ).length
        );
        categories = dateRange.map((date) => moment(date).format("MMM D"));
        break;
      }

      default:
        break;
    }

    return {
      chart: {
        type: "line",
        backgroundColor: "#fff",
        borderRadius: 10,
        height: 240,
        style: {
          fontFamily: "'Arial', sans-serif",
        },
      },
      title: {
        text: null,
      },
      xAxis: {
        categories,
        title: { text: null },
        labels: { style: { color: "#474747", fontSize: "10px" } },
        gridLineDashStyle: "dot",
        gridLineWidth: 2,
      },
      yAxis: {
        title: { text: null },
        labels: { style: { color: "#474747", fontSize: "12px" } },
        gridLineWidth: 0,
      },
      series: [
        {
          name: "Nurse",
          data: nurseDownloadData,
          color: "#4951EC",
          lineWidth: 1.2,
          marker: { enabled: false },
        },
        {
          name: "Physiotherapist",
          data: physioDownloadData,
          color: "#CE9DF4",
          lineWidth: 1.2,
          marker: { enabled: false },
        },
      ],
      legend: { enabled: false },
      credits: { enabled: false },
    };
  };

  return (
    <div className="h-50">
      <HighchartsReact highcharts={Highcharts} options={getOptions()} />
    </div>
  );
};

RevenueOverviewChartNursePhysio.propTypes = {
  value: PropTypes.string.isRequired,
  nurseData: PropTypes.array.isRequired,
  physioData: PropTypes.array.isRequired,
};

export default RevenueOverviewChartNursePhysio;
